import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/rentas-dhelos-white.svg'


const _hoisted_1 = { class: "flex flex-row items-center bg-darken-green top-0 h-16 sm:h-20 fixed z-30 shadow-lg px-4 sm:px-6 lg:px-12 w-full justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-full",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "flex flex-row w-full lg:w-max justify-between lg:justify-start items-center gap-4 sm:gap-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "hidden sm:flex text-[10px]" }, "Solicitud de movimiento", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "flex sm:hidden text-[10px] whitespace-nowrap" }, " Solicitar Movimiento ", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "flex flex-row items-center gap-4" }
const _hoisted_8 = {
  key: 0,
  class: "absolute top-10 text-black font-light -right-6 justify-center flex flex-row items-center p-2 bg-gray-200 rounded-lg shadow-lg text-xs"
}
const _hoisted_9 = {
  key: 0,
  class: "absolute top-10 -right-8 justify-center flex flex-row items-center p-2 bg-gray-200 rounded-lg shadow-lg text-xs"
}
const _hoisted_10 = {
  key: 0,
  class: "absolute top-10 -right-8 justify-center flex flex-row items-center p-2 bg-gray-200 rounded-lg shadow-lg text-xs"
}

import { ref, watchEffect } from "vue";
import { useAuthStore } from "@/stores/auth";

import NewMovementModal from "@/components/organisms/NewMovementModal.vue";
import NotificationMenu from "./NotificationMenu.vue";
import AccountMenu from "./AccountMenu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyTopbar',
  setup(__props) {


const showNewMovementModal = ref(false);
const authStore = useAuthStore();

const user = ref();
const tooltip = ref();

watchEffect(() => {
  const response = authStore.user;
  user.value = response;
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "lg:block hidden"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "bg-white rounded-full text-black flex gap-2 justify-center items-center button-solicitud",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showNewMovementModal.value = true))
        }, _hoisted_6),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "relative",
            onMouseover: _cache[1] || (_cache[1] = () => (tooltip.value = 3)),
            onMouseleave: _cache[2] || (_cache[2] = () => (tooltip.value = undefined)),
            onClick: _cache[3] || (_cache[3] = () => (tooltip.value = undefined))
          }, [
            _createVNode(_component_router_link, {
              class: "hover:text-light-green flex items-center gap-2 text-white",
              "active-class": "font-bold text-light-green",
              to: { name: 'MyStocks' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_mdicon, { name: "chart-bar" }),
                (tooltip.value == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Dashboard "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 32),
          _createElementVNode("div", {
            class: "relative",
            onMouseover: _cache[4] || (_cache[4] = () => (tooltip.value = 1)),
            onMouseleave: _cache[5] || (_cache[5] = () => (tooltip.value = undefined)),
            onClick: _cache[6] || (_cache[6] = () => (tooltip.value = undefined))
          }, [
            _createVNode(_component_router_link, {
              class: "hover:text-light-green flex items-center gap-2 text-white",
              "active-class": "font-bold text-light-green",
              to: { name: 'Invertions' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_mdicon, { name: "domain" })
              ]),
              _: 1
            }),
            (tooltip.value == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Inversiones "))
              : _createCommentVNode("", true)
          ], 32),
          _createElementVNode("div", {
            class: "relative",
            onMouseover: _cache[7] || (_cache[7] = () => (tooltip.value = 4)),
            onMouseleave: _cache[8] || (_cache[8] = () => (tooltip.value = undefined)),
            onClick: _cache[9] || (_cache[9] = () => (tooltip.value = undefined))
          }, [
            _createVNode(NotificationMenu),
            (tooltip.value == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Notificaciones "))
              : _createCommentVNode("", true)
          ], 32),
          (user.value)
            ? (_openBlock(), _createBlock(AccountMenu, {
                key: 0,
                user: user.value
              }, null, 8, ["user"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(NewMovementModal, {
      visible: showNewMovementModal.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((showNewMovementModal).value = $event))
    }, null, 8, ["visible"])
  ], 64))
}
}

})